import React from 'react';
import { Truck, Shield, RotateCcw } from 'lucide-react';

const features = [
  {
    icon: Truck,
    title: 'Free Shipping',
    description: 'On orders over $75',
  },
  {
    icon: Shield,
    title: 'Quality Guaranteed',
    description: 'Premium materials only',
  },
  {
    icon: RotateCcw,
    title: 'Easy Returns',
    description: '30-day return policy',
  },
];

export const FeatureBadges = () => {
  return (
    <section
      className="py-16 md:py-20 bg-wild-khaki/30"
      data-testid="feature-badges"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-8 bg-wild-sand border border-wild-khaki/50 hover:border-wild-leather/50 transition-colors duration-300"
              data-testid={`feature-badge-${index}`}
            >
              <div className="w-16 h-16 flex items-center justify-center bg-wild-leather/10 mb-6">
                <feature.icon className="h-8 w-8 text-wild-leather" />
              </div>
              <h3 className="font-headings text-2xl tracking-wider text-wild-dark mb-2">
                {feature.title}
              </h3>
              <p className="font-body text-wild-stone">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
